function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCallMicOni = function SvgCallMicOni(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "M12.8 20.44h1.667a.8.8 0 0 1 0 1.6H9.533a.8.8 0 0 1 0-1.6H11.2v-3.385a6.33 6.33 0 0 1-5.522-6.272.8.8 0 1 1 1.6 0c0 2.606 2.116 4.722 4.722 4.722s4.722-2.116 4.722-4.722a.8.8 0 1 1 1.6 0 6.33 6.33 0 0 1-5.522 6.272zm3.42-14.263c0-2.328-1.89-4.22-4.22-4.22a4.22 4.22 0 0 0-4.219 4.219v4.534A4.22 4.22 0 0 0 12 14.931a4.22 4.22 0 0 0 4.219-4.219V6.178zm-1.6 0v4.534a2.62 2.62 0 0 1-2.62 2.62 2.62 2.62 0 0 1-2.619-2.619V6.178A2.62 2.62 0 0 1 12 3.559a2.62 2.62 0 0 1 2.619 2.619z"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCallMicOni);
export default ForwardRef;